import "./nivelCarrera.scss";
import "../../components/atoms/buttons/button.scss";
import { memo } from "react";
import React, { useState, useEffect } from "react";
import "./../login/login.scss";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";
import { SpinnerCircle } from "../../components/atoms/spinner/Spinner";
import { useLocation, useNavigate } from "react-router-dom";
import AcumuladoresTab from "../../components/molecules/tabs/acumuladoresTab/AcumuladoresTab";
import ModalMensajes from "../../components/molecules/modals/modalMensajes/ModalMensajes";
import { useCurrentDate } from "../../utils/Utils";
import DecretoPDF from "../../resources/pdf/reconocimientoNivel/Decreto_DOE_23-11-2021.pdf";
import CorrecciónPDF from "../../resources/pdf/reconocimientoNivel/Correcion_decreto_doe.pdf";
import PlanPDF from "../../resources/pdf/reconocimientoNivel/huella_plan_de_valoracion.pdf";
import PreguntasPDF from "../../resources/pdf/reconocimientoNivel/preguntas_frecuentes.pdf";
import Button from "../../components/atoms/buttons/Button";

import {
  getVisiblidadPDF,
  getReconocimientos,
  getSolicitudesRealizadas,
} from "../../components/services/NivelCarreraService";
import Header from "../../components/molecules/header/Header";
import IfError from "../../components/molecules/ifError/IfError";
import Footer from "../../components/molecules/footer/Footer";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import ButtonVolver from "../../components/atoms/buttons/ButtonVolver";
import { getCodUltimaSolPresentada, getPDFSolicitud } from "../../components/services/ReconocimientoNivelService";

const NivelCarrera = () => {
  const [token] = useLocalStorage("token", "");
  const [usuario] = useLocalStorage("user", "");
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState({
    solicitudes: false,
    reconocimientos: false,
  });
  const [visibilidadRec, setVisibilidadRec] = useState(false);
  const navigate = useNavigate();
  const [documentos] = useState([
    {
      titulo: "Decreto 127/2021",
      link: DecretoPDF,
    },
    {
      titulo: "Corrección Decreto DOE",
      link: CorrecciónPDF,
    },
    {
      titulo: "Plan de Valoración",
      link: PlanPDF,
    },
    {
      titulo: "Preguntas Frecuentes",
      link: PreguntasPDF,
    },
  ]);
  const [reconocimientos, setReconocimientos] = useState([]);
  const [solicitudes, setSolicitudes] = useState([]);
  // const [ultimaSolicitudPresentada,setUltimaSolicitudPresentada] = useState(0);

  // const [activo] = useState([{ activo: true, mensaje: null }]);
  const [activo] = useState([
    {
      activo: true,
      mensaje: "La persona a la que se va a iniciar el Acto no está activa",
    },
  ]);

  const [show, setShow] = useState({
    mensaje: false,
  });

  const location = useLocation();
  const [paramSol, setParamSol] = useState(location?.state)
  



  useEffect(() => {
    const generarPDFsolicitud = (xwemprecnivcar2021) => {
      
      getPDFSolicitud(xwemprecnivcar2021).then((data) => {
        
        if (!data.toString().startsWith("Error:")) {
          const file = new Blob([data], {
            type: "application/pdf",
          });
          
          if (file.size !== 0) {
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement("a");
            link.href = fileURL;
            link.download = `RN_.pdf`;
            link.click();
            link.remove();

            handleShow({ mensaje: false });
          } else {

            handleShow({ mensaje: true });
          }
        } else {

          handleShow({ mensaje: true });
        }
      });
    }

    if (paramSol?.solPresentada) {
      getCodUltimaSolPresentada().then((data) => {
        
        handleShow({
          mensaje: true,
          titulo: "Su solicitud ha sido tramitada correctamente",
          texto:
            `El identificador de su solicitud es: ${usuario.niep}${data}`,
          texto2: "RECUERDE: en caso de haber cumplimentado el apartado 2.B \n" +
            " \"Méritos que deben ser acreditados por el/la interesado/a \", " +
            "deberá imprimir esta solicitud y presentarla, junto con la documentación " +
            "acreditativa de los méritos alegados en dicho apartado, a través de los " +
            "registros de entrada de documentos o lugares habilitados para ello, dirigida " +
            "a la Dirección General de Función Pública.",
          tipo: "tituloBorrador",
          funcion: generarPDFsolicitud,
          valorFuncion: data,
          destinoCerrar: null,
          destinoAviso: null,
        })
      })


      setParamSol((prevState) => ({
        ...prevState,
        solPresentada: false
      }))
    }

    getVisiblidadPDF(usuario.niep).then((data) => {
      
      setVisibilidadRec(data.visibilidad);
      if (!data.toString().startsWith("Error:")) {
        setLoading(true);
      }
    });

    if (visibilidadRec) {
      getReconocimientos(usuario.niep).then((data) => {
        setReconocimientos(data);
        
        setLoadingData((prevState) => ({
          ...prevState,
          reconocimientos: true,
        }));
      });
    }

    getSolicitudesRealizadas(usuario?.niep).then((data) => {
      setSolicitudes(data);
      
      setLoadingData((prevState) => ({
        ...prevState,
        solicitudes: true,
      }));
    });
  }, [loading, token, usuario, visibilidadRec, paramSol]);




  const handleShow = (e) => {
    setShow(e);
  };
  const handleClose = (e) => {
    setShow(false);
  };
  const [fechaActual] = useCurrentDate("-");

  const handleResolucion = (id) => {
    //llamar al back
    

    let solicitudesNueva = [];
    for (let i = 0; i < solicitudes.length; i++) {
      if (solicitudes[i].codigo === id) {
        solicitudes[i].fechaResolucion = fechaActual;
      }
      solicitudesNueva.push(solicitudes[i]);
    }
    setSolicitudes(solicitudesNueva);
  };

  function NivelCarrera() {
    return (
      <>
        <div className="vh-100">
          <Header></Header>
          {/* Documentos */}
          <div className="contanier d-flex flex-column align-items-center m-lg-5 m-md-5 m-sm-3  p-2" role="main" data-landmark-index="4">
            {loading ? (
              <>
                <div className="container d-flex justify-content-start">
                  {/*<Titulo
                    tipo={"tituloModal "}
                    titulo={"Reconocimiento de Nivel de Carrera"}
                  />*/}
                  <h2 className="tituloPagina">Reconocimiento y Solicitudes de Nivel de Carrera (En deshuso)</h2>
                </div>
                <p className="mt-2">
                  Los siguientes documentos contienen información de interés
                  acerca de la carrera profesional:
                </p>
                <div className="container d-flex justify-content-between py-3 btnDocumentos">
                  {documentos.map((documento, i) => (
                    <button
                      className="btn2 m-2 p-1"
                      type="button"
                      key={i}
                      onClick={() => window.open(documento.link)}
                    >
                      <i className="fa fa-file"></i> {documento.titulo}{" "}
                    </button>
                  ))}
                </div>


                {/* solicitudes y reconocimientos */}
                <div className="row d-flex justify-content-center tablaRecNivel">
                  <div className="row col-12 card pb-5">
                    {}
                    {}
                    {/* {solicitudes !== 0 || reconocimientos !== 0 ? (
                      <> */}
                        <AcumuladoresTab
                          solicitudes={solicitudes}
                          reconocimientos={reconocimientos}
                          visibilidadRec={visibilidadRec}
                          handleResolucion={handleResolucion}
                          loading={loadingData}
                        />
                      {/* </>
                    ) : (
                      <>
                        <SpinnerCircle></SpinnerCircle>
                      </>
                    )} */}
                  </div>
                </div>
                <div className="d-flex align-items-center">

                <ButtonVolver destino={"home"} clases="rounded col-3 mt-3 mb-3"></ButtonVolver>
                  <Button
                    id="btnNuevaSolicitudNC"
                    clases="btn-card rounded seleccion-mes mt-3 mb-3 "
                    nombre={
                      <>
                        <i className="fa-solid fa-file-circle-plus"></i> Nueva
                        Solicitud
                      </>
                    }
                    tipo="button"
                    funcion={() =>
                      activo[0].activo
                        ? navigate("/solicitudCarrera")
                        : handleShow({
                          mensaje: true,
                          content: activo[0].mensaje,
                        })
                    }
                  />
                  
                </div>
              </>
            ) : (
              <>
                {visibilidadRec !== false ? (
                  <>
                    <IfError
                      mensage="Error: Fallo en la conexión con el servidor"
                      ruta="/home"
                    ></IfError>
                  </>
                ) : (
                  <SpinnerCircle></SpinnerCircle>
                )}
              </>
            )}
            <br />
          </div>
          <Footer></Footer>
        </div>
        {show.mensaje ? (
          <ModalMensajes
            show={show.mensaje}
            handleClose={handleClose}
            titulo={show.titulo}
            texto={show.texto}
            texto2={show.texto2}
            content={show.content}
            destinoCerrar={show?.destinoCerrar}
            tipo={show?.tipo}
            funcion={show?.funcion}
            valorFuncion={show?.valorFuncion}
          ></ModalMensajes>
        ) : null}
      </>
    );
  }

  return <>{NivelCarrera()}</>;
};

export default memo(NivelCarrera);
